<template>
  <q-btn flat noCaps rounded>
    <span class="q-btn__content__text">
      <slot/>
    </span>
  </q-btn>
</template>

<script setup lang="ts">
</script>
